import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "image-gallery" };
const _hoisted_2 = {
    key: 0,
    class: "thumbnail d-none d-lg-block"
};
const _hoisted_3 = { class: "h-100 position-relative" };
const _hoisted_4 = { class: "thumbnail__container" };
const _hoisted_5 = ["onMouseover"];
const _hoisted_6 = { class: "image-wrapper" };
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = { class: "image" };
const _hoisted_9 = {
    key: 0,
    class: "product-flags__container product-flags__left"
};
const _hoisted_10 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_video = _resolveComponent("g-video");
    const _component_v_horizontal = _resolveComponent("v-horizontal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.images && _ctx.images.length > 0 && _ctx.showThumbnails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("ul", {
                            onScroll: _cache[0] || (_cache[0] = ($event) => (_ctx.OnScroll($event)))
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
                                return (_openBlock(), _createElementBlock("li", null, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["image-container", { 'image-active': _ctx.isActiveImage(image) }]),
                                        onMouseover: ($event) => (_ctx.OnSelect(image))
                                    }, [
                                        _createElementVNode("div", _hoisted_6, [
                                            (_ctx.isVideo(image.address))
                                                ? (_openBlock(), _createBlock(_component_g_video, {
                                                    key: 0,
                                                    mode: "thumbnail",
                                                    src: image.address,
                                                    class: "gallery-image",
                                                    alt: image.caption
                                                }, null, 8, ["src", "alt"]))
                                                : (_openBlock(), _createElementBlock("img", {
                                                    key: 1,
                                                    src: image.previewUrl,
                                                    class: "gallery-image",
                                                    alt: image.caption
                                                }, null, 8, _hoisted_7))
                                        ])
                                    ], 42, _hoisted_5)
                                ]));
                            }), 256))
                        ], 32)
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
            (_ctx.flags && _ctx.flags.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flags, (flag) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(['flag', flag.cssClass]),
                            style: _normalizeStyle({ color: flag.foreColor, 'background-color': flag.backgroundColor })
                        }, _toDisplayString(flag.caption), 7));
                    }), 256))
                ]))
                : _createCommentVNode("", true),
            (_ctx.images && _ctx.images.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "image__container",
                    style: _normalizeStyle({ padding: _ctx.imageSpacing })
                }, [
                    _createVNode(_component_v_horizontal, {
                        ref: "slider",
                        class: "horizontal w-100 h-100",
                        button: _ctx.$appHost.pageMeta.isMediaSizeDown('lg'),
                        "show-indicators": _ctx.$appHost.pageMeta.isMediaSizeDown('lg'),
                        onScrollDebounce: _ctx.onScrollDebounce
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "item w-100 h-100 position-relative",
                                    style: { "margin": "2px" },
                                    key: item.id
                                }, [
                                    (_ctx.isVideo(item.address))
                                        ? (_openBlock(), _createBlock(_component_g_video, {
                                            key: 0,
                                            mode: "player",
                                            src: item.address,
                                            class: "gallery-image",
                                            alt: item.caption
                                        }, null, 8, ["src", "alt"]))
                                        : (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            onMousemove: _cache[1] || (_cache[1] =
                                                //@ts-ignore
                                                (...args) => (_ctx.imgMouseMove && _ctx.imgMouseMove(...args))),
                                            onMouseenter: _cache[2] || (_cache[2] =
                                                //@ts-ignore
                                                (...args) => (_ctx.imgMouseEntry && _ctx.imgMouseEntry(...args))),
                                            onMouseleave: _cache[3] || (_cache[3] =
                                                //@ts-ignore
                                                (...args) => (_ctx.imgMouseLeave && _ctx.imgMouseLeave(...args))),
                                            src: item.fullUrl,
                                            alt: item.caption,
                                            class: "gallery-image",
                                            onClick: _cache[4] || (_cache[4] =
                                                //@ts-ignore
                                                (...args) => (_ctx.OnImagelick && _ctx.OnImagelick(...args)))
                                        }, null, 40, _hoisted_10))
                                ]));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["button", "show-indicators", "onScrollDebounce"])
                ], 4))
                : _createCommentVNode("", true)
        ])
    ]));
}
